module.exports = [
	{
		"message": "Hope you have a relaxed holiday",
		"image": "landscape"
	},
	{
		"message": "Summer is near",
		"image": "flower"
	},
	{
		"message": "Have a nice evening",
		"image": "sunset"
	},
	{
		"message": "Some flowers for you...",
		"image": "flower"
	}
]


/*****************
 ** WEBPACK FOOTER
 ** ./src/cards.json
 ** module id = 157
 ** module chunks = 0
 **/